import Rollbar from "rollbar";

const code_version =
  process.env.VERCEL_GIT_COMMIT_SHA ||
  process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA;
const environment =
  process.env.VERCEL_TARGET_ENV || process.env.NEXT_PUBLIC_VERCEL_TARGET_ENV;

const baseConfig = {
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: process.env.VERCEL_TARGET_ENV,
  code_version,
  server: {
    root: "webpack://_N_E/",
  },
  payload: {
    environment,
    client: {
      javascript: {
        code_version,
        source_map_enabled: true,
      },
    },
  },
  recorder: {
    enabled: true,
    autostart: true,
    blockClass: "rb-block",
    maskTextClass: "rb-mask",
    ignoreClass: "rb-ignore",
    maskAllInputs: true,
  },
};

console.log("rollbar baseConfig", JSON.stringify(baseConfig));

export const clientConfig = {
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN,
  ...baseConfig,
};

export const serverInstance = new Rollbar({
  accessToken: process.env.ROLLBAR_SERVER_TOKEN,
  ...baseConfig,
});
